<template>
  <div
    class="modal fade auth-modal"
    id="authModal"
    tabindex="-1"
    aria-labelledby="authModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <img src="@/assets/images/logo.svg" alt="Info Global Logo" />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="closeButton"
          ></button>
        </div>
        <div class="modal-body">
          <component
            :is="currentView"
            @switchView="switchView"
            @close="closeModal"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, defineComponent, onMounted } from "vue";
import AuthView from "../AuthView.vue";
import ForgotPasswordView from "../ForgotPasswordView.vue";
import RegisterView from "../RegisterView.vue";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "AuthModal",
  components: {
    AuthView,
    ForgotPasswordView,
    RegisterView,
  },
  setup() {
    const currentView = ref("RegisterView");
    const closeButton = ref(null);
    let modalInstance = null;

    const switchView = (view) => {
      currentView.value = view;
    };
    const closeModal = () => {
      currentView.value = "RegisterView";
      closeButton.value.click();
    };
    const openModal = () => {
      if (modalInstance) {
        modalInstance.show();
      }
    };

    onMounted(() => {
      const modalElement = document.getElementById("authModal");
      if (modalElement) {
        modalInstance = new Modal(modalElement);
        modalElement.addEventListener("hide.bs.modal", () => {
          currentView.value = "RegisterView";
        });
      } else {
        console.error("Модальное окно не найдено");
      }
    });
    return {
      currentView,
      closeButton,
      switchView,
      closeModal,
      openModal,
    };
  },
});
</script>

<style lang="scss">
@import "@/assets/styles/auth.scss";
</style>
